import React, { useCallback } from 'react';
import { Keyboard } from 'react-native';
import { getSyncingStatus, syncSingleAccountConnection, } from 'actions/connections';
import { muteErrorAndResult, useFetchOld } from 'hooks/useFetch';
import { useAppDispatch, useAppStore } from 'store/hooks';
import { useIsTierUnlockedForSpace } from 'features/premium/hooks/useIsTierUnlockedForSpace';
import { benefits } from 'features/premium/benefits';
import Modal from 'utils/packages/Modal';
import { Tier } from 'features/premium/entities';
import { selectUserTier } from 'features/premium/selectors/tier';
import ForceSyncUpgradeModal from './ForceSyncUpgradeModal';
const useForceSyncSingle = () => {
    const store = useAppStore();
    const dispatch = useAppDispatch();
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResult);
    const isUnlockedForSpace = useIsTierUnlockedForSpace(benefits.forceSync.minTier);
    const forceSyncSingle = useCallback(async (accountId, onUpgrade) => {
        const state = store.getState();
        const userTier = selectUserTier(state);
        if (isUnlockedForSpace) {
            const result = await fetch(syncSingleAccountConnection(accountId));
            if (result) {
                dispatch(getSyncingStatus());
            }
            return result;
        }
        const showModal = () => Modal.show(<ForceSyncUpgradeModal />, {
            title: userTier === Tier.plus
                ? 'Emma updates 4 times a day'
                : 'Emma updates once a day',
        });
        Keyboard.dismiss();
        if (onUpgrade) {
            onUpgrade(showModal);
        }
        else {
            showModal();
        }
        return null;
    }, [isUnlockedForSpace]);
    return [isFetching, forceSyncSingle];
};
export default useForceSyncSingle;
